import React, { DragEvent, useContext, useState } from "react";
import { CardMedia, Stack, useColorScheme, useTheme } from "@mui/material";
import { DraftCharacter } from "types/Draft/type";
import CharacterBadges from "pages/Draft/CharacterBadges";
import { DividerVertical } from "assets/icons";
import { API_URL } from "service/root/rootApi";
import { RoomContext } from "App/context";
import { GameMode } from "types/Room/type";
import { motion, AnimatePresence } from "motion/react";

type PicksListType = {
  player: "player1" | "player2";
  picks: DraftCharacter[];
  onDrop?: (order: DraftCharacter[]) => void;
};

const PicksList = (props: PicksListType) => {
  const { params } = useContext(RoomContext);
  const [dragChar, setDragChar] = useState<DraftCharacter | undefined>(
    undefined
  );
  const { player, picks, onDrop } = props;
  const { palette } = useTheme();
  const isAbyssMode = params.gameMode === GameMode.SpiralAbyss;

  const handleDragStart = (char: DraftCharacter) => () => {
    setDragChar(char);
  };

  const handleDragOver = () => (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const handleDrop =
    (toChar: DraftCharacter) => (event: DragEvent<HTMLDivElement>) => {
      if (onDrop && dragChar) {
        event.preventDefault();
        let tmp = picks.slice();
        const fromIndex =
          picks.findIndex((character) => character.name === dragChar.name) ??
          -1;
        const toIndex =
          picks.findIndex((character) => character.name === toChar.name) ?? -1;

        tmp[fromIndex] = toChar;
        tmp[toIndex] = dragChar;
        onDrop(tmp);
        setDragChar(undefined);
      }
    };


  return (
    <Stack
      direction="row"
      height="1vh"
      width="100%"
      flexGrow={1}
      gap={1}
      key={1}
      sx={{ svg: { height: "100%" } }}
    >
      <AnimatePresence>
        {[...Array(isAbyssMode ? 9 : 14).keys()].map((value) => {
          if (value === 4 || value === 9)
            return <DividerVertical key={value} />;
          const currentIndex =
            value > 9 ? value - 2 : value > 4 ? value - 1 : value;
          return (
            <motion.div
              key={picks[currentIndex].name}
              initial={{ scale: 0 }}
              animate={{
                scale: 1,
              }}
              layout
              {...(onDrop !== undefined
                ? {
                    draggable: true,
                    onDragStart: handleDragStart(picks[currentIndex]),
                    onDragOver: handleDragOver(),
                    onDrop: handleDrop(picks[currentIndex]),
                  }
                : {})}
              style={{
                position: "relative",
                borderRadius: "1rem",
                overflow: "hidden",
                width: "100%",
                border: `2px solid ${palette.common[player].borderConstel}`,
              }}
            >
              <CardMedia
                key={value}
                component="img"
                src={`${API_URL}assets/genshin/characters/${picks[currentIndex].name}/drip.png`}
                title={picks[currentIndex].name}
                sx={{
                  borderRadius: "1rem",
                  marginTop: isAbyssMode ? "unset" : "2rem",
                  transform: `scale(${isAbyssMode ? 1.35 : 1.8})`,
                  cursor: onDrop !== undefined ? "move" : "unset",
                }}
              />
              <CharacterBadges
                character={picks[currentIndex]}
                side={player}
              />
            </motion.div>
          );
        })}
      </AnimatePresence>
    </Stack>
  );
};

export default PicksList;
